// extracted by css-extract-rspack-plugin
export default {"cls1":"BundleGrid-cls1_qxx","cls2":"BundleGrid-cls2_uWo BundleGrid-cls1_qxx"};